// import React, { useState } from "react";
// import { TextField } from "@mui/material";
// import { styled } from "@mui/system";
// import NumFormato from "./numerico";

// const CustomTextField = styled(TextField)(
//   ({
//     TamanioFuente,
//     Alineacion,
//     ColorFuente,
//     BackColor,
//     labelStyle,
//     maxLength,
//     inputMode,
//     redOnlyProp,
//   }) => ({
//     "& .MuiInputBase-input": {
//       textAlign: Alineacion || "right",
//       fontSize: TamanioFuente || "20px",
//       color: ColorFuente || "black",
//       background: BackColor || "white",
//     },
//     "& .MuiInputLabel-root": {
//       ...(labelStyle || {}),
//     },
//   })
// );

// const TextFieldCustom = ({
//   TamanioFuente,
//   Alineacion,
//   ColorFuente,
//   BackColor,
//   labelStyle,
//   decimal = false,
//   decimalCantidad = 1,
//   isNumeric = false,
//   maxLength,
//   inputMode = "text",
//   onFocus,
//   onBlur,
//   onChange,
//   Negativo = false, // Nuevo parámetro para permitir negativos
//   redOnlyProp = false,
//   ...otherProps
// }) => {
//   const [isFocused, setIsFocused] = useState(false);

//   const handleFocus = (e) => {
//     let value = e.target.value;
//     setIsFocused(true);
//     if (onFocus) {
//       if (isNumeric) {
//         const numCant = NumFormato.NumeroSinFormato(value);
//         if (parseFloat(numCant.replace(",", ".")) === 0) {
//           e.target.value = "";
//         } else {
//           e.target.value = numCant;
//         }
//       }
//       onFocus(e);
//     }
//   };

//   const handleBlur = (e) => {
//     let value = e.target.value;
//     setIsFocused(false);
//     if (onBlur) {
//       if (isNumeric) {
//         const numCant = NumFormato.NumeroFormateado(
//           value,
//           false,
//           decimal,
//           decimalCantidad
//         );
//         e.target.value = numCant;
//       }
//     }
//     onBlur(e);
//   };

//   // const handleInputChange = (e) => {
//   //   let value = e.target.value;

//   //   if (maxLength && value.length > maxLength) {
//   //     value = value.slice(0, maxLength);
//   //   }

//   //   if (isNumeric) {
//   //     if (decimal) {

//   //       value = value.replace(/[^0-9,.]/g, "");
//   //       const parts = value.split(/[,.]/);
//   //       if (parts.length > 2) {
//   //         value = parts[0] + "." + parts.slice(1).join("");
//   //       }

//   //     } else {
//   //       value = value.replace(/[^0-9]/g, "");
//   //     }
//   //     e.target.value = value;
//   //     if (!isFocused) {
//   //       const formattedValue = decimal
//   //         ? formatDecimal(value)
//   //         : formatInteger(value);
//   //       e.target.value = formattedValue;
//   //     }
//   //   }
//   //   if (onChange) {
//   //     onChange(value); // Llama a la función onChange pasando el nuevo valor
//   //   }
//   // };
//   const handleInputChange = (e) => {
//     let value = e.target.value;

//     if (maxLength && value.length > maxLength) {
//       value = value.slice(0, maxLength);
//     }

//     if (isNumeric) {
//       if (decimal) {
//         // Permitir números, coma, punto y el signo negativo al inicio (si está permitido)
//         value = value.replace(/[^0-9.,-]/g, "");

//         // Si allowNegative es verdadero, permitir el signo negativo solo al principio
//         if (Negativo && value.includes("-")) {
//           value = "-" + value.replace(/-/g, "");
//         }

//         // Manejar múltiples comas o puntos
//         const parts = value.split(/[,.]/);
//         if (parts.length > 2) {
//           value = parts[0] + "." + parts.slice(1).join("");
//         }
//       } else {
//         // Permitir solo números y el signo negativo al inicio (si está permitido)
//         value = value.replace(/[^0-9-]/g, "");

//         if (Negativo && value.includes("-")) {
//           value = "-" + value.replace(/-/g, "");
//         }
//       }
//     }
//     e.target.value = value;
//     if (!isFocused) {
//       const formattedValue = decimal
//         ? formatDecimal(value)
//         : formatInteger(value);
//       e.target.value = formattedValue;
//     }

//     if (onChange) {
//       onChange(value); // Llama a la función onChange pasando el nuevo valor
//     }
//   };

//   const handleKeyDown = (value) => {
//     onkeydown(value); // Llama a la función onChange pasando el nuevo valor
//   };

//   const formatInteger = (value) => {
//     return value;
//   };

//   const formatDecimal = (value) => {
//     return value.replace(".", ",");
//   };

//   return (
//     <CustomTextField
//       TamanioFuente={TamanioFuente}
//       Alineacion={Alineacion}
//       ColorFuente={ColorFuente}
//       BackColor={BackColor}
//       labelStyle={labelStyle}
//       isNumeric={isNumeric}
//       onFocus={handleFocus}
//       onBlur={handleBlur}
//       onChange={handleInputChange}
//       onKeyDown={handleKeyDown} // al soltar un boton
//       inputProps={{
//         inputMode: inputMode,
//         maxLength: maxLength,
//         readOnly: redOnlyProp, // ⬅️ evita que escriban a mano
//       }}
//       {...otherProps}
//     />
//   );
// };

// export default TextFieldCustom;
import React, { useState } from "react";
import { TextField } from "@mui/material";
import { styled } from "@mui/system";
import NumFormato from "./numerico";
/* ===============================
   1️⃣ DEFINICIÓN DE CustomTextField
   =============================== */

const CustomTextField = styled(TextField, {
  shouldForwardProp: (prop) =>
    ![
      "TamanioFuente",
      "Alineacion",
      "ColorFuente",
      "BackColor",
      "labelStyle",
      "isNumeric",
      "decimal",
      "decimalCantidad",
      "Negativo",
      "redOnlyProp",
    ].includes(prop),
})(({ TamanioFuente, Alineacion, ColorFuente, BackColor, labelStyle }) => ({
  "& .MuiInputBase-input": {
    textAlign: Alineacion || "right",
    fontSize: TamanioFuente || "20px",
    color: ColorFuente || "black",
    backgroundColor: BackColor || "white",
  },
  "& .MuiInputLabel-root": {
    ...(labelStyle || {}),
  },
}));

/* ===============================
   2️⃣ COMPONENTE TextFieldCustom
   =============================== */

const TextFieldCustom = ({
  TamanioFuente,
  Alineacion,
  ColorFuente,
  BackColor,
  labelStyle,
  decimal = false,
  decimalCantidad = 1,
  isNumeric = false,
  maxLength,
  inputMode = "text",
  onFocus,
  onBlur,
  onChange,
  Negativo = false,
  redOnlyProp = false,
  ...otherProps
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = (e) => {
    setIsFocused(true);
    if (isNumeric) {
      const numCant = NumFormato.NumeroSinFormato(e.target.value);
      e.target.value =
        parseFloat(numCant.replace(",", ".")) === 0 ? "" : numCant;
    }
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    if (isNumeric) {
      e.target.value = NumFormato.NumeroFormateado(
        e.target.value,
        false,
        decimal,
        decimalCantidad,
      );
    }
    onBlur?.(e);
  };

  const handleInputChange = (e) => {
    let value = e.target.value;

    if (maxLength && value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    if (isNumeric) {
      value = decimal
        ? value.replace(/[^0-9.,-]/g, "")
        : value.replace(/[^0-9-]/g, "");

      if (Negativo && value.includes("-")) {
        value = "-" + value.replace(/-/g, "");
      }
    }

    e.target.value = value;
    onChange?.(value);
  };

  return (
    <CustomTextField
      {...otherProps}
      TamanioFuente={TamanioFuente}
      Alineacion={Alineacion}
      ColorFuente={ColorFuente}
      BackColor={BackColor}
      labelStyle={labelStyle}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onChange={handleInputChange}
      inputProps={{
        inputMode,
        maxLength,
        readOnly: redOnlyProp,
      }}
    />
  );
};

export default TextFieldCustom;
